<template>
  <div class="text-center">
    <v-menu offset-x>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon color="primary" dark v-bind="attrs" v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item v-for="(item, index) in items" :key="index">
          <v-list-item-title @click.stop="showModalHandler(index)">
            {{ item.title }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <AddRecipient
      @closedialog="closedialog()"
      :showaddrecipient="shouldshowaddrecipient"
      :currentlySelectedAccount="currentlySelectedAccount"
      :acls="acls"
      :channel="channel"
      @refreshconversations="refreshConversations()"
    />
    <RemoveRecipient
      @closedialog="closedialog()"
      :showremoverecipient="shouldshowremoverecipient"
      :currentlySelectedAccount="currentlySelectedAccount"
      :acls="acls"
      :channel="channel"
      @refreshconversations="refreshConversations()"
    />
    <DeleteChannel
      @closedialog="closedialog()"
      :showdeletechannel="shouldshowDeleteChannelModal"
      :currentlySelectedAccount="currentlySelectedAccount"
      :acls="acls"
      :channel="channel"
      @refreshconversations="refreshConversations()"
    />
  </div>
</template>
<script>
import AddRecipient from "./channelmenu/addrecipient.vue";
import RemoveRecipient from "./channelmenu/removerecipient.vue";
import DeleteChannel from "./channelmenu/deleteChannel.vue";
export default {
  props: {
    acls: Array,
    currentlySelectedAccount: String,
    recordsIamAuthorizedOn: Array,
    channel: Object,
  },
  components: { AddRecipient, RemoveRecipient, DeleteChannel },
  data: () => ({
    shouldshowaddrecipient: false,
    shouldshowremoverecipient: false,
    shouldshowDeleteChannelModal: false,
    items: [
      { title: "Add to channel" },
      { title: "Remove from channel" },
      { title: "Delete channel" },
    ],
  }),
  methods: {
    showModalHandler(index) {
      if (index === 0) {
        this.showAddRecipientModal();
      } else if (index === 1) {
        this.showRemoveRecipientModal();
      } else if (index === 2) {
        this.showDeleteChannelModal();
      }
    },
    showAddRecipientModal() {
      this.shouldshowaddrecipient = true;
    },
    showRemoveRecipientModal() {
      this.shouldshowremoverecipient = true;
    },
    showDeleteChannelModal() {
      this.shouldshowDeleteChannelModal = true;
    },
    closedialog() {
      this.shouldshowaddrecipient = false;
      this.shouldshowremoverecipient = false;
      this.shouldshowDeleteChannelModal = false;
    },
    refreshConversations() {
      this.$emit("refreshconversations");
    },
  },
};
</script>
